import './Texture.less';
import { Unity, useUnityContext } from 'react-unity-webgl';
import { useEffect, useRef, useState } from 'react';
import Thumbnail from '@/assets/Thumbnail.png';
import Sidebar from './components/Sidebar/Sidebar.jsx';
import Rightbar from './components/Rightbar/Rightbar.jsx';
import Generate from './components/Generate/Generate.jsx';
import { SDService, projectController } from '@/api';
import img2imgPng1 from '@/utils/texture1.js';
import img2imgPng2 from '@/utils/texture2.js';
import img2imgPng3 from '@/utils/texture3.js';
import { useParams } from 'react-router-dom';
import { fileToBase64 } from '@/utils/file.js';
const controlObj = { cancel: false };

import { Spin } from 'antd';
import { wait } from '@/utils/utils.js';
import toast from 'react-hot-toast';
import { gen2D, getInpaintTextures, OnCancelGenerate } from '@/utils/unityTool.js';
export default function Home() {
  const [loading, setLoading] = useState(false);
  const [progression, setProgression] = useState(0);
  const [progress, setProgress] = useState(0);
  const [generateImages, setGenerateImages] = useState(null);
  const [showGenerate, setShowGenerate] = useState(false);
  const { projectId } = useParams(); // 获取路径参数

  const [brushIsPaint, setBrushIsPaint] = useState(false);
  const [layer, setLayer] = useState(null);
  const [rightbarKey, setRightbarKey] = useState(1);
  const [textureNoseLoaded, setTextureNoseLoaded] = useState(false);
  const rightbarRef = useRef();
  const sidebarRef = useRef();

  const { unityProvider, isLoaded, loadingProgression, sendMessage, unload } = useUnityContext({
    // loaderUrl: `/Build/webgl.loader.js`,
    // dataUrl: `/Build/webgl.data.unityweb`,
    // frameworkUrl: `/Build/webgl.framework.js.unityweb`,
    // codeUrl: `/Build/webgl.wasm.unityweb`,
    // workerUrl: `/Build/webgl.data.unityweb`,
    // streamingAssetsUrl: 'StreamingAssets',
    // companyName: 'MRStage',
    // productName: 'AITexturePainter',
    // productVersion: 'v0.1-20250411-r4',
    loaderUrl: `/test-unity/html/Build/html.loader.js`,
    dataUrl: `/test-unity/html/Build/html.data.gz`,
    frameworkUrl: `/test-unity/html/Build/html.framework.js.gz`,
    codeUrl: `/test-unity/html/Build/html.wasm.gz`,
    workerUrl: `/test-unity/html/Build/html.data.gz`,
    streamingAssetsUrl: '/test-unity/html/StreamingAssets',
    companyName: 'MRStage',
    productName: 'AITexturePainter',
    productVersion: 'v0.1-20250411-r4',
    // 关键配置：禁用键盘捕获
    webglContextAttributes: {
      preserveDrawingBuffer: true,
      keyboardFocus: false, // 允许页面输入框接收键盘事件
    },
  });

  useEffect(() => {
    // 可以在这里添加事件监听或初始化逻辑

    return () => {
      console.log('unload 返回：', unload());

      // 销毁 Unity WebGL 实例
      unload()
        .then(() => {
          console.log('Unity 卸载完成');
        })
        .catch((err) => {
          console.warn('卸载失败：', err);
        });
    };
  }, []);

  const sendMessageRef = useRef(sendMessage);

  useEffect(() => {
    setProgression((loadingProgression * 100).toFixed());
  }, [loadingProgression]);
  useEffect(() => {
    setLoading(isLoaded);
    if (isLoaded) {
    }
    window.addEventListener('keydown', (e) => {}, true);
  }, [isLoaded]);

  useEffect(() => {
    window.textureNoseFinishLoad = () => {
      console.log('textureNoseFinishLoad');
      queryDetail();
    };
    sidebarRef.current.resetInpant();
  }, []);

  useEffect(() => {
    sendMessageRef.current = sendMessage; // 同步最新引用
  }, [sendMessage]);

  useEffect(() => {
    console.log('brushIsPaint', brushIsPaint);
    sidebarRef.current.changeInpant(brushIsPaint);
  }, [brushIsPaint]);

  const queryDetail = async () => {
    const res = await projectController.detail({
      projectId: projectId,
    });

    if (res.code == 0) {
      setTextureNoseLoaded(true);
      sendMessageRef.current('ContextManager', 'OnCmdExec', 'LoadUrl ' + res.data.resources[0].url);
    }
  };

  // 上传图片
  const uploadTexture = async (file) => {
    let base64 = await fileToBase64(file);
    base64 = base64.split(',')[1];
    sendMessage('ContextManager', 'OnCmdExec', 'SetLayerTexture ' + base64);
  };

  // 生成
  const generate = async (params) => {
    try {
      console.log('generate');
      rightbarRef.current.resetValues();
      await wait(500);
      controlObj.cancel = false;
      setShowGenerate(true);
      setGenerateImages(null);
      setProgress(0);
      // setRightbarKey(rightbarKey + 1);
      if (brushIsPaint) {
        window.returnBaseTextures = async (msg) => {
          const base64s = msg.split(',,,');
          const base64InputTexture = base64s[0];
          const base64InpaintTexture = base64s[1];
          const base64ControlNetImageTexture = base64s[2];
          document.getElementById('initImage').src = 'data:image/jpg;base64, ' + base64InputTexture;
          document.getElementById('inpaintImage').src =
            'data:image/jpg;base64, ' + base64InpaintTexture;
          document.getElementById('controlNetImage').src =
            'data:image/jpg;base64, ' + base64ControlNetImageTexture;

          if (!base64InputTexture || !base64InpaintTexture || !base64ControlNetImageTexture) {
            toast('waiting texture,please try again');
            setShowGenerate(true);
            setGenerateImages(null);
            setProgress(0);
            return;
          }

          const res = await SDService.submitTaskAndResponse(
            '/sdapi/v1/img2img',
            {
              prompt: params.prompt,
              negative_prompt: params.negative_prompt,
              sampler_name: params.sampler_name,
              hr_sampler_name: params.hr_sampler_name,
              cfg_scale: params.cfg_scale,
              batch_size: 1,
              n_iter: 1,
              resize_mode: 0,
              steps: params.steps,
              width: params.width,
              height: params.height,
              enable_hr_spz: false,
              hr_scale_spz: 1.0,
              seed: params.seed,
              refiner_checkpoint: '',
              refiner_switch_at: 0.56,
              tiling: false,
              save_detected_map: false,
              inpainting_fill: 1,
              inpaint_full_res: 0,
              inpaint_full_res_padding: 0,
              inpainting_mask_invert: 0,
              mask_blur: 0.0,
              denoising_strength: params.denoising_strength,
              include_init_images: true,
              init_images: [base64InputTexture],
              mask: base64InpaintTexture,
              alwayson_scripts: {
                'soft inpainting': {
                  args: [
                    {
                      'Soft inpainting': true,
                      'Schedule bias': 1.0,
                      'Preservation strength': 0.5,
                      'Transition contrast boost': 4,
                      'Mask influence': 0.0,
                      'Difference threshold': 0.5,
                      'Difference contrast': 2,
                    },
                  ],
                },
                controlnet: {
                  args: [
                    {
                      ...params.alwayson_scripts.controlnet.args[0],
                      image: base64ControlNetImageTexture,
                      module: 'None',
                    },
                  ],
                },
              },
            },
            (progress) => {
              setProgress(progress);
            },
            controlObj,
          );
          if (!controlObj.cancel) {
            document.getElementById('resultImage').src =
              'data:image/jpg;base64, ' + res.raw_output.processed_images[0].data;

            setGenerateImages(res.raw_output.processed_images);
            const raw_forge_output = res.raw_output.raw_forge_output;
            const info = JSON.parse(raw_forge_output.info);
            console.log('返回的随机数====', info.seed);
            const seed = info.seed;
            sidebarRef.current.settingLastSeed(seed);
            await wait(1000);
            setBrushIsPaint(false);
          }
        };
      } else {
        window.returnBaseTextures = async (msg) => {
          const base64s = msg.split(',,,');
          const base64ControlNetImageTexture = base64s[2];

          document.getElementById('controlNetImage').src =
            'data:image/jpg;base64, ' + base64ControlNetImageTexture;

          params.alwayson_scripts.controlnet.args[0].image = base64ControlNetImageTexture;
          const res = await SDService.submitTaskAndResponse(
            '/sdapi/v1/txt2img',
            params,
            (progress) => {
              setProgress(progress);
            },
            controlObj,
          );
          if (!controlObj.cancel) {
            const raw_forge_output = res.raw_output.raw_forge_output;
            const info = JSON.parse(raw_forge_output.info);
            console.log('info====', info);

            const seed = info.seed;
            console.log('返回的随机数====', info.seed);
            sidebarRef.current.settingLastSeed(seed);

            setGenerateImages(res.raw_output.processed_images);
          }
        };
      }

      gen2D(sendMessage);

      setTimeout(() => {
        getInpaintTextures(sendMessage);
      }, 3000);
    } catch (error) {
      console.error(error);
    }
  };

  // 选择图片
  const chooseImage = (item) => {
    setGenerateImages([item]);
    setShowGenerate(false);
    sendMessage('ContextManager', 'OnCmdExec', 'SetProjectImage ' + item.data);
    rightbarRef.current.onGenerateFinish(generateImages.length===1);
  };

  const changeBrushAndLayer = (brush, layer) => {
    sendMessage('ContextManager', 'OnCmdExec', 'brushOpen ' + 1 + ' 1');
    setBrush(brush);
    setLayer(layer);
  };

  return (
    <div className="texture">
      <Sidebar
        className="sidebar"
        ref={sidebarRef}
        onUploadTexture={(file) => {
          uploadTexture(file);
        }}
        sendMessage={sendMessage}
        onGenerate={(params) => {
          generate(params);
        }}></Sidebar>
      <div className="content">
        {!loading && (
          <div className="loadingState">
            <img src={Thumbnail} />
            <div className="progress">
              <div className="progressItem" style={{ width: `${progression}%` }} />
              <div className="label">{progression}%</div>
            </div>
          </div>
        )}
        <div className="p-images">
          <div>
            <span>初始图</span>
            <img id="initImage"></img>
          </div>
          <div>
            <span>绘制图</span>
            <img id="inpaintImage"></img>
          </div>
          <div>
            <span>controlnet</span>
            <img id="controlNetImage"></img>
          </div>
          <div>
            <span>结果图</span>
            <img id="resultImage"></img>
          </div>
          <div>
            <span>渲染图</span>
            <img id="renderImage"></img>
          </div>
        </div>
        <div className="unity-content">
          <Unity unityProvider={unityProvider} style={{ height: '100%', width: '100%' }} />
        </div>
        {!textureNoseLoaded && loading ? (
          <Spin className="spin-load" spinning={!textureNoseLoaded}></Spin>
        ) : (
          <></>
        )}
      </div>
      <Rightbar
        ref={rightbarRef}
        key={rightbarKey}
        onBrushIsPaint={(value) => {
          setBrushIsPaint(value);
        }}
        className="rightbar"
        sendMessage={sendMessage}
        images={generateImages}></Rightbar>

      {showGenerate ? (
        <Generate
          single={brushIsPaint}
          sendMessage={sendMessage}
          onClose={() => {
            setGenerateImages(null);
            setShowGenerate(false);
            controlObj.cancel = true;
            OnCancelGenerate(sendMessage);
          }}
          onChooseImage={(item) => {
            chooseImage(item);
          }}
          progress={progress}
          images={generateImages}
          className="generate"></Generate>
      ) : (
        <></>
      )}
    </div>
  );
}
